// export const BASE_URL = `https://cms-and-backend-7uw7.onrender.com`
//export const BASE_URL = `http://localhost:5001`

export const BASE_URL = `https://cms-and-backend-rwvk.onrender.com`


export const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN || 'artistintro.com';

// Plan types
export const PLAN_TYPES = {
  FREE: 'free',
  PAID: 'paid',
} as const;

// Free plan limits
export const FREE_PLAN_LIMITS = {
  themes: 1,
  banners: 1,
  toursEvents: 1,
  showcases: 5,
  images: 3,
  awards: 1,
  canAddCategories: false,
  contactLeadsAccess: false,
};

// Resource type labels for display
export const RESOURCE_LABELS: Record<string, string> = {
  showcases: 'Showcase Songs',
  images: 'Image Gallery',
  banners: 'Promo Banners',
  toursEvents: 'Tours & Events',
  awards: 'Awards',
  themes: 'Themes',
  categories: 'Custom Categories',
  contactLeadsAccess: 'Website Leads',
};
